module.exports = __webpack_public_path__ + "static/media/bne.0c38e0b7.png";